import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";
import React, { Component } from "react";
import { Table, Button, Badge, ListGroup, OverlayTrigger, Tooltip, Form, Dropdown } from 'react-bootstrap';
import ArrowBackSharpIcon from "@material-ui/icons/ArrowBackSharp";
import Replied from '../../../component/campaigns/charts/replied';
import SMSSend from '../../../component/campaigns/charts/sms-send';
import EmailSend from '../../../component/campaigns/charts/email-send';
import SystemHack from '../../../component/campaigns/charts/system-hack';
import CallPicked from '../../../component/campaigns/charts/call-picked';
import MessageSent from '../../../component/campaigns/charts/message-send';
import EmailOpened from '../../../component/campaigns/charts/email-opened';
import LinkClicked from '../../../component/campaigns/charts/link-clicked';
import DataSubmitted from '../../../component/campaigns/charts/data-submitted';
import EmailReported from '../../../component/campaigns/charts/email-reported';
import CallInitiated from '../../../component/campaigns/charts/call-initiated';
import Error from '../../../component/campaigns/charts/error';
import NewBreachReportGraph from '../../../component/campaigns/reports/new-breach-report';
import SumarryReportGraph from '../../../component/campaigns/reports/summary-report';
import AttachmentOpened from '../../../component/campaigns/charts/attachment-opened'
import axios from '../../../axios';
import apiError from '../../../error';
import { formateToLocalDate, getCookie } from '../../../function';
import './reports.css';
import { toast } from 'react-toastify';
import Spinner from '../../../component/spinner/spinner';
import swal from 'sweetalert';
import DateRangeSharpIcon from '@material-ui/icons/DateRangeSharp';
import RightSideModalScheduler from '../../../component/rightside-modal/right-modal-schedular';
import RightSideModalSendReportToEmails from '../../../component/rightside-modal/send-report-to-emails';
import { debounce } from '../../../function';
import CallReceived from '../../../component/campaigns/charts/call-received';
import DebouncedLoader from '../../../component/loader/debounced-loader';
export default class CampaignReport extends Component {

    constructor(props) {
        super(props);
        this.printReport = this.printReport.bind(this);
        this.reportRef = React.createRef();
        this.keyMetricsRef = React.createRef();
        this.mvDepBarRef = React.createRef();
        this.mvDesBarRef = React.createRef();
        this.mvLocBarRef = React.createRef();
        this.depWiseSummaryPieRef = React.createRef();
        this.desWiseSummaryPieRef = React.createRef();
        this.locWiseSummaryPieRef = React.createRef();
        this.phishRiskBarRef = React.createRef();
        this.blobs = null;
        this.newBlobs = [
            { sectionId: 'campaign-summary', blobs: [
                {filename: "raw-phish-risk-bar-chart.png", blob: null, ref: this.phishRiskBarRef}
            ]},
            { sectionId: 'key-metrics', blobs: [
                {filename: "raw-key-metrics-chart.png", blob: null, ref: this.keyMetricsRef}
            ] },
            { sectionId: 'vulnerability-summary', blobs: [
                {filename: "raw-mv-dep-bar-chart.png", blob: null, ref: this.mvDepBarRef},
                {filename: "raw-mv-des-bar-chart.png", blob: null, ref: this.mvDesBarRef},
                {filename: "raw-mv-loc-bar-chart.png", blob: null, ref: this.mvLocBarRef},
            ] },
            { sectionId: 'department-wise-summary', blobs: [
                {filename: "raw-dep-wise-summary-pie-chart.png", blob: null, ref: this.depWiseSummaryPieRef}
            ] },
            { sectionId: 'designation-wise-summary', blobs: [
                {filename: "raw-des-wise-summary-pie-chart.png", blob: null, ref: this.desWiseSummaryPieRef}
            ] },
            { sectionId: 'location-wise-summary', blobs: [
                {filename: "raw-loc-wise-summary-pie-chart.png", blob: null, ref: this.locWiseSummaryPieRef}] },
        ];
        this.state = {
            loading: true,
            status: {},
            results: [],
            details: {},
            show: false,
            breachTime: null,
            currentRisk: null,
            industryRisk: null,
            incidentTime: 0,
            campaignName: '',
            toDate: new Date(),
            fromDate: new Date(),
            credentialHarvesting: null,
            campaignId: parseInt(this.props.match.params.campaignId, 10),
            simulationId: parseInt(this.props.match.params.simulationId, 10),
            time: [],
            value: [],
            isRepliedCampaign: false,
            value: props.value || 80,
            min: props.min || 0,
            max: props.max || 100,
            pointerPosition: '50%',
            campaignStatus: '',
            mostVulnerableEmployees: [],
            departmentWiseSummary: [],
            departmentWisePieChart: null,
            locationWiseSummary: null,
            locationWisePieChart: null,
            designationWiseSummary: null,
            designationWisePieChart: null,
            attackType: '',
            totalTargetsCount: 0,
            averageEvsScore: 'NA',
            isReportGenerating: false,
            disableDownloadReport: true,
            showSchedulerModal: false,
            latestSimulationExpiresOn: null,
            campaignReportScheduler: null,
            showSendReportToEmailsModal: false,
            reportSectionIds: null,
            reportSections: {
                campaignSummary: true,
                templateDetails: true,
                keyMetrics: true,
                vulnerabilitySummary: true,
                departmentWiseSummary: true,
                locationWiseSummary: true,
                designationWiseSummary: true,
                summaryConclusion: true,
            },
            sidebarFixed: false,
            isReportDownloaded: false,
            targetInteractionType: "inbound"
        }
    }

    componentDidMount = async() => {
        window.addEventListener('scroll', this.handleScroll);
        this.phishRate();
        this.loadTotal();
        this.getDetails();
        this.loadBreachAndIncident();
        this.getMostVulnerableEmployees();
        this.fetchCampaignReportSchedulerByCampaignId();
        this.fetchExecutiveReportSection();
        setTimeout(() => { //A fallback method to force enable the download button after 10 seconds
            this.setState({ disableDownloadReport: false });
        }, 10000);
    }
    async componentDidUpdate(prevProps, prevState) {
        if (
            (prevState.attackType !== this.state.attackType ||
                prevState.credentialHarvesting !== this.state.credentialHarvesting) && this.state.attackType && this.state.credentialHarvesting !== null
        ) {
            await Promise.all([
                this.getMostVulnerableDepartMentsAsPerEVS(),
                this.getMostVulnerableLocationsAsPerEVS(),
                this.getMostVulnerableDesignationsAsPerEVS()
            ])
            
        }

        if((
            prevState.currentRisk !== this.state.currentRisk ||
            prevState.industryRisk !== this.state.industryRisk || 
            prevState.averageEvsScore !== this.state.averageEvsScore ||
            prevState.breachTime !== this.state.breachTime ||
            prevState.status !== this.state.status ||
            prevState.departmentWisePieChart !== this.state.departmentWisePieChart ||
            prevState.locationWisePieChart !== this.state.locationWisePieChart ||
            prevState.designationWisePieChart !== this.state.designationWisePieChart || 
            prevState.reportSectionIds !== this.state.reportSectionIds
        ) && 
            this.state.currentRisk!==null &&
            this.state.industryRisk!==null &&
            this.state.averageEvsScore!=="NA" &&
            this.state.breachTime!==null &&
            this.state.status && Object.keys(this.state.status).length !== 0 &&
            this.state.departmentWisePieChart!==null &&
            this.state.locationWisePieChart!==null &&
            this.state.designationWisePieChart!==null && 
            this.state.reportSectionIds!==null

        ){
            this.generateBlobsWithInternalDebouncing();
        }
    }

componentWillUnmount = async () => {
  window.removeEventListener('scroll', this.handleScroll);
}

handleScroll = () => {
  const breadcrumb = document.querySelector('.breadcrumbbar');
  if (!breadcrumb) return;
  const rect = breadcrumb.getBoundingClientRect();
  // If bottom of breadcrumbbar is above the top of viewport, it's hidden
  const isHidden = rect.bottom <= 0;
  if (isHidden !== this.state.sidebarFixed) {
    this.setState({ sidebarFixed: isHidden });
  }
}


    fetchExecutiveReportSection = async () => {
        try {
            this.setState({loading: true});
            const response = await axios.get(`/api/pdfReport/get-executive-report-sections/${this.state.simulationId}`, {
            });
            this.setState({reportSectionIds: response.data.executiveReportSectionIds || [], loading: false});
        }
        catch (error) {
            this.setState({loading: false});
            apiError(error);
        }
    }

    updateExecutiveReportSection = async (updatedIds) => {
        try {
            this.setState({loading: true});
            const response = await axios.post(`/api/pdfReport/update-executive-report-sections/${this.state.simulationId}`, {
                executiveReportSectionIds: updatedIds
            });
            this.setState({reportSectionIds: updatedIds, loading: false});
        }
        catch (error) {
            this.setState({loading: false});
            apiError(error);
        }
    }

    loadGraph = () => {
        axios.get('/api/campaigns/graph', {
            params: {
                campaignId: this.state.campaignId,
                simulationId: this.state.simulationId
            },
        })
            .then(res => {
                var value = [], time = [];
                for (let i = 0; i < res.data.results.length; i++) {
                    if (res.data.results[i].time) {
                        const formattedDate = formateToLocalDate(res.data.results[i].time);
                        value.push(res.data.results[i].count);
                        time.push(formattedDate);
                    }
                }
                this.setState({ value, time });
            })
            .catch(error => {
                apiError(error);
            })
    }

    loadTotal = () => {
        axios.get('/api/simulation/', {
            params: {
                campaignId: this.state.campaignId,
                simulationId: this.state.simulationId
            },
        })
            .then(res => {
                if (res.data.simulation) {
                    var status = {};
                    for (var i = 0; i < res.data.simulation.status.length; i++) {
                        var data = res.data.simulation.status[i];
                        status[data['message']] = parseInt(data['count'], 10) ? parseInt(data['count'], 10) : 0;
                    }
                    this.setState({
                        status: status,
                        loading: false,
                        isRepliedCampaign: res.data.simulation.isRepliedCampaign,
                        attackType: (res.data.simulation.campaign && res.data.simulation.campaign.attack_type) ? res.data.simulation.campaign.attack_type.name : '',
                        campaignStatus: ((res.data.simulation?.completesOn && new Date(res.data.simulation.completesOn)<=new Date() )? "Completed" : "In Progress"),
                        totalTargetsCount: (res.data.simulation.targetsCount || "---"),
                        targetInteractionType: (res.data.simulation.targetInteractionType),
                        credentialHarvesting: !!res.data.simulation.credentialHarvesting,
                    })
                }
            })
            .catch(error => {
                apiError(error);
            })
    }

    loadBreachAndIncident = async () => {
        try {
            const response = await axios.get('/api/results/breach/incedent', {
                params: {
                    campaignId: this.state.campaignId,
                    simulationId: this.state.simulationId
                },
            });

            if (response.data.result_be) {
                this.setState({ breachTime: response.data.result_be.breachTime ? this.formatDuration(response.data.result_be.breachTime) : "0 sec" });
            }
            if (response.data.result_in) {
                this.setState({ incedent: this.formatDuration(response.data.result_in.incidentTime) });
            }
        } catch (err) {
            apiError(err);
        }
    }

    getDetails = async () => {
        try {
            const response = await axios.get('/api/campaigns/details', {
                params: { campaignId: this.state.campaignId, simulationId: this.state.simulationId },
            });

            const campaignStartDate = new Date(response.data.details.scheduledAt);
            let campaignCompleteDate = new Date(response.data.details.completedAt)
            if (response.data.details.completedAt) {
                campaignCompleteDate = new Date(response.data.details.completedAt);
            }
            const campaignEndDate = campaignCompleteDate;
            
            const campaign = response.data.details && response.data.details.campaign ? response.data.details.campaign : null;
            const campaignName = campaign ? campaign.name : "";

            this.setState({
                toDate: campaignEndDate,
                fromDate: campaignStartDate,
                details: response.data.details,
                campaignName: campaignName,
            });
        } catch (error) {
            apiError(error);
        }
    }

    /** True if credential harvesting is enabled for this simulation. Sourced from `/api/simulation` (`simulation.credentialHarvesting`). */
    isAssignTemplatesCredentialHarvestingEnabled = () => {
        return !!this.state.credentialHarvesting;
    };

    // Renders the Template Details view used when a campaign has more than one
    // template ("Random" mode). Matches the report mockup: a "Template Details"
    // summary box (mode / language / simulation type / credential harvesting)
    // followed by a separate numbered "Templates N" section per template, each
    // with its own detail table and Email/Landing/Awareness thumbnail columns.
    // The single-template layout is left untouched; this is only invoked when
    // length > 1.
    renderMultiTemplateDetails = () => {
        const assignTemplates = this.state.details?.assign_simulation_templates ?? [];
        const attackType = this.state.attackType;
        const interaction = this.state.targetInteractionType;
        const primary = assignTemplates?.[0]?.campaign_template || {};

        // Which per-template columns/rows make sense for this attack type (mirrors
        // the single-template section's show/hide rules).
        const isMessage = attackType === "Telegram" || attackType === "Smishing";
        const showEmail =
            ["Phishing", "QRcode", "Attachment", "Ransomware"].includes(attackType) ||
            (attackType === "Vishing" && interaction === "inbound") ||
            (attackType === "WhatsApp" && interaction === "inbound");
        const showLanding =
            (attackType === "Ransomware" || !!this.state.credentialHarvesting) &&
            attackType !== "Attachment" &&
            attackType !== "Vishing" &&
            !(attackType === "WhatsApp" && interaction === "inbound");
        const showAwareness =
            attackType !== "Ransomware" &&
            attackType !== "Vishing" &&
            !(attackType === "WhatsApp" && interaction === "inbound");

        const showCredentialHarvesting =
            !(attackType === "Vishing" && interaction === "outbound") &&
            attackType !== "Attachment" &&
            attackType !== "Ransomware";

        const Yn = (val) => (
            <Badge bg="primary" className={val ? "custom-badge-success" : "custom-badge-danger"}>
                {val ? "Yes" : "No"}
            </Badge>
        );

        const columnCount = (showEmail || isMessage ? 1 : 0) + (showLanding ? 1 : 0) + (showAwareness ? 1 : 0);

        return (
            <div className="pdf-card-wrap">
                {/* Summary box (campaign-level template details) */}
                <div className="heading">
                    <h5>Template Details</h5>
                </div>
                <div className="card-body-wrap">
                    <Table className="borderless-table">
                        <tbody>
                            <tr>
                                <td>Template Mode :</td>
                                <td>
                                    <Badge bg="primary" className="custom-badge-info">Random</Badge>
                                    <span className="ms-2">( {assignTemplates.length} Template Used )</span>
                                </td>
                            </tr>
                            <tr>
                                <td>Type of Simulation :</td>
                                <td>{this.state.details?.simulation_type?.name}</td>
                            </tr>
                            {showCredentialHarvesting &&
                                <tr>
                                    <td>Credential Harvesting :</td>
                                    <td>{Yn(this.isAssignTemplatesCredentialHarvestingEnabled())}</td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </div>

                {/* One numbered section per template */}
                {assignTemplates.map((at, idx) => {
                    const ct = at?.campaign_template || {};
                    return (
                        <div className="multi-template-section" key={at?.campaignTemplateId ?? ct?.id ?? idx}>
                            <div className="heading">
                                <h5>Template {idx + 1}</h5>
                            </div>
                            <div className="card-body-wrap">
                                <Table className="borderless-table">
                                    <tbody>
                                        <tr>
                                            <td>Template Name :</td>
                                            <td>{ct?.name}</td>
                                        </tr>
                                        {showEmail &&
                                            <tr>
                                                <td>Subject Name :</td>
                                                <td>{ct?.template?.subject}</td>
                                            </tr>
                                        }
                                        <tr>
                                            <td>Template Category :</td>
                                            <td>{ct?.category?.name}</td>
                                        </tr>
                                        <tr>
                                            <td>Language :</td>
                                            <td>{ct?.language?.name}</td>
                                        </tr>
                                
                                        {showLanding && showCredentialHarvesting &&
                                            <tr>
                                                <td>Capture Credentials :</td>
                                                <td>{Yn(ct?.page?.capture_credentials == 1)}</td>
                                            </tr>
                                        }
                                        {showLanding && showCredentialHarvesting &&
                                            <tr>
                                                <td>Credential Password :</td>
                                                <td>{Yn(ct?.page?.capture_passwords == 1)}</td>
                                            </tr>
                                        }
                                    </tbody>
                                </Table>
                            </div>
                            <div className="card-body-wrap">
                                <div className="multi-template-cols" style={{ gridTemplateColumns: `repeat(${columnCount || 1}, 1fr)` }}>
                                    {(showEmail || isMessage) &&
                                        <div className="multi-template-col">
                                            <div className="multi-template-colhead">{isMessage ? "Message Template" : "Email Template"}</div>
                                            {!isMessage &&
                                                <p className="multi-template-meta"><span>Attacker Profile :</span> <span className="multi-template-value">{ct?.sender?.from_address || "---"}</span></p>
                                            }
                                            <div className="multi-template-thumb">
                                                {ct?.templatePath ? <img src={ct.templatePath} alt="Email template" /> : null}
                                            </div>
                                        </div>
                                    }
                                    {showLanding &&
                                        <div className="multi-template-col">
                                            <div className="multi-template-colhead">Landing Page</div>
                                            <p className="multi-template-meta"><span>URL :</span> <span className="multi-template-value">{ct?.page?.landing_url || "---"}</span></p>
                                            <div className="multi-template-thumb">
                                                {ct?.pagePath ? <img src={ct.pagePath} alt="Landing page" /> : null}
                                            </div>
                                        </div>
                                    }
                                    {showAwareness &&
                                        <div className="multi-template-col">
                                            <div className="multi-template-colhead">Awareness Page</div>
                                            <p className="multi-template-meta"><span>URL :</span> <span className="multi-template-value">{ct?.awarenessUrl || this.state.details?.awarenessUrl || "---"}</span></p>
                                            <div className="multi-template-thumb">
                                                {ct?.awarenessPath ? <img src={ct.awarenessPath} alt="Awareness page" /> : null}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    phishRate = async () => {
        try {
            const response = await axios.get('/api/campaigns/phishRate', {
                params: { campaignId: this.state.campaignId, simulationId: this.state.simulationId },
            });
            this.setState({
                currentRisk: Number(Number(response.data.currentRisk || 0).toFixed(2)),
                industryRisk: Number(Number(response.data.industryRisk || 4.3).toFixed(2)),
            });
        } catch (error) {
            apiError(error);
        }
    }

    first5HackedUser = () => {
        axios.get('/api/results/first5', {
            params: { campaignId: this.state.campaignId, simulationId: this.state.simulationId },
        })
            .then(res => {
                this.setState({ results: res.data.results });
            })
            .catch(error => apiError(error))
    }

    secondsToHms = (d) => {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? (h < 10 ? "0" : "") + h + " : " : "00 : ";
        var mDisplay = m > 0 ? (m < 10 ? "0" : "") + m + " : " : "00 : ";
        var sDisplay = s > 0 ? (s < 10 ? "0" : "") + s + "" : "00";
        return hDisplay + mDisplay + sDisplay;
    }

    printReport = () => {
        this.setState({ isReportGenerating: true });
        html2canvas(this.reportRef.current).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            let imageHeight = this.reportRef.current?.clientHeight;
            let imageWidth = this.reportRef.current?.clientWidth;
            let ratio = imageHeight / imageWidth;

            const pdf = new jsPDF({
                unit: 'pt',
                format: [canvas.width + 40, canvas.height + 40]
            });

            let pdfWidth = pdf.internal.pageSize.getWidth() - 40;
            let pdfHeight = pdfWidth * ratio;

            pdf.addImage(imgData, "JPEG", 20, 0, pdfWidth, pdfHeight);
            pdf.save(`Report.pdf`);
            this.setState({ isReportGenerating: false });
        }).catch(err => {
            this.setState({ isReportGenerating: false });
            apiError(err);
        });
    }
    formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

        const day = String(date.getDate()).padStart(2, '0');
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    }

    getMostVulnerableEmployees = async () => {
        try {
            const response = await axios.get(`/api/simulation/mostVulnerableEmployees/${this.state.simulationId}`, {});
            this.setState({ mostVulnerableEmployees: response.data.results, averageEvsScore: Number(parseFloat(response.data.averageEvsScore || 0).toFixed(2)) });
        } catch (error) {
            apiError(error);
        }
    }

    getMostVulnerableDepartMentsAsPerEVS = async () => {
        try {
            const response = await axios.get(`/api/simulation/getMostVulnerableDepartMentsAsPerEVS/${this.state.simulationId}`, { params: { attackType: this.state.attackType, credentialHarvesting: this.state.credentialHarvesting ? 1 : 0 } });
            this.setState({ departmentWiseSummary: response.data.results, departmentWisePieChart: response.data?.results?.map(r => { return { label: r.department, value: r.evsScore } }) });
        } catch (error) {
            apiError(error);
        }
    }
    getMostVulnerableLocationsAsPerEVS = async () => {
        try {
            const response = await axios.get(`/api/simulation/getMostVulnerableLocationsAsPerEVS/${this.state.simulationId}`, { params: { attackType: this.state.attackType, credentialHarvesting: this.state.credentialHarvesting ? 1 : 0 } });
            this.setState({ locationWiseSummary: response.data.results, locationWisePieChart: response.data?.results?.map(r => { return { label: r.location, value: r.evsScore } }) });
        } catch (error) {
            apiError(error);
        }
    }
    getMostVulnerableDesignationsAsPerEVS = async () => {
        try {
            const response = await axios.get(`/api/simulation/getMostVulnerableDesignationsAsPerEVS/${this.state.simulationId}`, { params: { attackType: this.state.attackType, credentialHarvesting: this.state.credentialHarvesting ? 1 : 0 } });
            this.setState({ designationWiseSummary: response.data.results, designationWisePieChart: response.data?.results?.map(r => { return { label: r.designation, value: r.evsScore } }) });
        } catch (error) {
            apiError(error);
        }
    }




    formatDuration = (seconds) => {
        if (!seconds || seconds == 0 || typeof seconds !== "number") return "---";
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        const parts = [];
        if (hrs > 0) parts.push(`${hrs} hr`);
        if (mins > 0) parts.push(`${mins} min`);
        if (secs > 0 || parts.length === 0) parts.push(`${secs} sec`);

        return parts.join(' ');
    }

    setGraphBlobs = async () => {
        const promiseArray = [
            html2canvas(this.keyMetricsRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.phishRiskBarRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.mvDepBarRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.mvDesBarRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.mvLocBarRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.depWiseSummaryPieRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.desWiseSummaryPieRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))),
            html2canvas(this.locWiseSummaryPieRef.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve)))
        ];
        this.blobs = await Promise.all(promiseArray)
        this.setState({ disableDownloadReport: false });
        return this.blobs;
    }

    generatePdf = async ({sendReportToEmails, languageCode="en"}) => {
        try {
            this.setState({ isReportGenerating: true })
            let keyMetricsTableRows = this.prepareKeyMetricTable();

            const formData = new FormData();

            await this.generateBlobsWithInternalDebouncing();

            const filenames = [
                "raw-key-metrics-chart.png",
                "raw-phish-risk-bar-chart.png",
                "raw-mv-dep-bar-chart.png",
                "raw-mv-des-bar-chart.png",
                "raw-mv-loc-bar-chart.png",
                "raw-dep-wise-summary-pie-chart.png",
                "raw-des-wise-summary-pie-chart.png",
                "raw-loc-wise-summary-pie-chart.png"
            ];

            this.newBlobs.forEach(section => {
                section.blobs.forEach((blobObj) => {
                    const blob = blobObj.blob;
                    if (blob) {
                        formData.append("screenshots", blob, blobObj.filename);
                    }
                })
            })


            formData.append("campaignName", this.state.campaignName);
            formData.append("attackVector", this.state.attackType);
            formData.append("launchedBy", "---");
            formData.append("startDate", this.formatDate(this.state.fromDate));
            formData.append("endDate", this.formatDate(this.state.toDate));
            formData.append("totalUsers", this.state.totalTargetsCount);
            formData.append("groups", JSON.stringify((this.state.details?.campaign?.campaign_groups ?? [])
                .filter(cg => cg?.group?.type !== "simulation-generated")
                .map(cg =>
                cg.group?.name?.startsWith("ALL-Users-IN-COMPANY-") ? `all-users-tsat (${cg.group?.targetsCount})` :
                    `${cg.group?.name} (${cg.group?.targetsCount})`
            )));
            formData.append("campaignStatus", this.state.campaignStatus);
            formData.append("templateName", this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.name + ' '));
            formData.append("templateCategory", this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.category?.name + ' '));
            formData.append("language", this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.language?.name + ' '));
            formData.append("simulationType", this.state.details?.simulation_type?.name ?? "");
            // Credential harvesting is read from the simulation now (this.state.credentialHarvesting sourced from /api/simulation).
            formData.append("credentialHarvesting", this.state.credentialHarvesting ? "Yes" : "No");
            formData.append("emailTemplateSubject", this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.template?.subject);
            formData.append("emailTemplateAttackerProfile", this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.sender?.from_address);
            formData.append("landingPageURL", this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.landing_url);
            formData.append("landingPageCaptureCredentials", this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_credentials == 1 ? "Yes" : "No");
            formData.append("landingPageCapturePassword", this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_passwords == 1 ? "Yes" : "No");
            formData.append("keyMetricsTable", JSON.stringify({ headers: ['Metric', 'Value', 'Percentage'], rows: keyMetricsTableRows }));
            formData.append("awarenessURL", this.state.details.awarenessUrl);
            formData.append("averageEvsScore", this.state.averageEvsScore);
            formData.append("averageBreachTime", this.state.breachTime);
            formData.append("sendReportToEmails", sendReportToEmails);
            formData.append("languageCode", languageCode);
            if (getCookie('campaignReportSchedulerId')) {
                formData.append("campaignReportSchedulerId", getCookie('campaignReportSchedulerId'));
            }
            if (getCookie('pseudoToday')) {
                formData.append("pseudoToday", getCookie('pseudoToday'));
            }
            if (getCookie('pseudoYesterday')) {
                formData.append("pseudoYesterday", getCookie('pseudoYesterday'));
            }
            if (getCookie('scheduledDate')) {
                formData.append("scheduledDate", getCookie('scheduledDate'));
            }
            let templateThumbnail = this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.template?.thumbnail;
            if (templateThumbnail) formData.append("templateThumbnail", templateThumbnail);
            let pageThumbnail = this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.thumbnail;
            if (pageThumbnail) formData.append("pageThumbnail", pageThumbnail);
            let thumbnailAdvisory = this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.thumbnail_advisory;
            formData.append("awarenessThumbnail", this.state.details?.awarenessThumbnail || thumbnailAdvisory);

            // ── Multiple-template ("Random" mode) support ──
            // A campaign with more than one template is treated as Random mode.
            // We send every template's details plus its three thumbnails so the
            // report can render a "Templates Used" grid with one row per
            // template. Single-template campaigns keep the legacy [0] path above
            // and this block is skipped, so their output is unchanged.
            const assignTemplatesForReport = this.state.details?.assign_simulation_templates ?? [];
            if (assignTemplatesForReport.length > 1) {
                formData.append("isMultiTemplate", "true");
                formData.append("templateCount", assignTemplatesForReport.length);
                formData.append("templateMode", "Random");
                const templatesUsed = assignTemplatesForReport.map(at => {
                    const ct = at?.campaign_template || {};
                    return {
                        name: ct?.name ?? "",
                        subject: ct?.template?.subject ?? "",
                        category: ct?.category?.name ?? "",
                        language: ct?.language?.name ?? "",
                        // type + credential harvesting are campaign/simulation-level now
                        simulationType: this.state.details?.simulation_type?.name ?? "",
                        credentialHarvesting: this.state.credentialHarvesting ? "Yes" : "No",
                        attackerProfile: ct?.sender?.from_address ?? "",
                        landingURL: ct?.page?.landing_url ?? "",
                        awarenessURL: ct?.awarenessUrl ?? this.state.details?.awarenessUrl ?? "",
                        captureCredentials: ct?.page?.capture_credentials == 1 ? "Yes" : "No",
                        capturePassword: ct?.page?.capture_passwords == 1 ? "Yes" : "No",
                        templateThumbnail: ct?.template?.thumbnail ?? "",
                        pageThumbnail: ct?.page?.thumbnail ?? "",
                        // Use this template's own awareness thumbnail. The backend sets
                        // ct.awarenessThumbnail from the template's awareness_pages[0].thumbnail
                        // (works for both credential-harvesting on and off). page.thumbnail_advisory
                        // is only populated when credential harvesting is ON, so relying on it made
                        // every template fall back to the campaign-level (first template's) awareness
                        // page when credential harvesting was OFF.
                        awarenessThumbnail: ct?.awarenessThumbnail ?? ct?.page?.thumbnail_advisory ?? this.state.details?.awarenessThumbnail ?? "",
                    };
                });
                formData.append("templatesUsed", JSON.stringify(templatesUsed));
            }
            const TotalCount = this.state.status['Total'] ? this.state.status['Total'] : 1;
            const sentCount = this.state.status['Email Sent'] || this.state.status['SMS Sent'] || this.state.status['Message Sent'] || this.state.status['Call Initiated'] || TotalCount;
            const linkRisk = Number(((this.state.status['Link Clicked'] * 100) / sentCount).toFixed(2)) || 0;
            formData.append("linkRisk", linkRisk);
            formData.append("industryRisk", this.state.industryRisk);
            formData.append("phishRisk", (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment" || this.state.attackType === "Ransomware") ? this.state.currentRisk : linkRisk);

            const response = await axios.post(`/api/pdfReport/genereatePdf/${this.state.simulationId}/${this.state.campaignId}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                responseType: 'blob'
            });
            this.setState({ isReportGenerating: false, isReportDownloaded: true })

            if(getCookie('pseudoToday')) {
                return;
            }

            if (sendReportToEmails?.length) {
                toast.success("Report sent successfully to the recipients.");
                return;
            }
            if (response.data?.type === 'application/json') {
                const { url } = JSON.parse(await response.data.text());
                if (url) {
                    window.open(url, '_blank');
                    return;
                }
            }
            // this.setGraphBlobs();
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = this.state.campaignName + '-report.pdf';      // filename
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            this.setState({ isReportGenerating: false })
            if (error.response?.status === 500) {
                swal({
                    title: "Error generating PDF",
                    icon: "info",
                    text: "You may proceed to download the report as a PDF screenshot.",
                    buttons: ["Cancel", "Proceed"],
                    dangerMode: true,
                }).then((willSuccess) => {
                    if (willSuccess) {
                        this.printReport();
                    }
                });
            } else {
                apiError(error);
            }
        }
    };


    prepareKeyMetricTable = () => {
        const { status, attackType, isRepliedCampaign } = this.state;
        const TotalCount = this.state.status['Total'] ? this.state.status['Total'] : 1;
        const keyMetricTable = [];

        const metrics = [
            { key: 'Email Sent', label: 'Emails Sent', condition: true },
            { key: 'SMS Sent', label: 'SMS Sent', condition: true },
            { key: 'Message Sent', label: 'Message Sent', condition: true },
            { key: 'Call Initiated', label: 'Call Initiated', condition: true },
            { key: 'Call Picked', label: 'Call Picked', condition: true },
            { key: 'Email Opened', label: 'Emails Opened', condition: true },
            { key: 'Link Clicked', label: 'Links Clicked', condition: true },
            { key: 'Call Received', label: 'Calls Received', condition: true },
        ];

        if (this.state.credentialHarvesting || (attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| attackType === "Attachment") {
            metrics.push(
                { key: 'Data Submitted', label: 'Data Submitted', condition: true },
                { key: 'Attachment Opened', label: 'Attachment Opened', condition: true },
                { key: 'System Hacks', label: 'System Hacks', condition: true }
            )
        }
        metrics.push({ key: 'Replied', label: 'Replied', condition: isRepliedCampaign });
        metrics.push({ key: 'Error', label: 'Error', condition: this.state.status['Error'] > 0 });
        metrics.push({ key: 'Email Reported', label: 'Emails Reported', condition: this.state.status['Email Reported'] > 0 });

        metrics.forEach(metric => {
            if (metric.key in status && metric.condition) {
                const count = status[metric.key];
                const percentage = Number(((count * 100) / TotalCount).toFixed(2)) + '%';
                if (metric.key === "Link Clicked" && this.state.attackType === "QRcode") {
                    metric.label = "*QR Scanned*";
                }
                keyMetricTable.push([metric.label, count, percentage]);
            }
        });

        return keyMetricTable;
    }

    fetchCampaignReportSchedulerByCampaignId = async () => {
        try {
            const res = await axios.get(`/api/pdfReport/schedule/campaign/${this.state.campaignId}`);
            if (res.data) {
                this.setState({ campaignReportScheduler: res.data.campaignReportScheduler || null, latestSimulationExpiresOn: res.data.latestSimulationExpiresOn || null });
            }
        } catch (error) {
            apiError(error);
        }
    }

    debouncedGeneratePdf = debounce(async() => {
        if(getCookie('campaignReportSchedulerId') && getCookie('pseudoToday') && getCookie('pseudoYesterday') && getCookie('scheduledDate')) {
            await this.generatePdf({});
        }
    }, 2000, true)

    generateBlobsWithInternalDebouncing = debounce(async () => {
        for(let sectionId of (this.state.reportSectionIds || [])){
            const section = this.newBlobs.find(sb => sb.sectionId === sectionId);
            if(section){
                for(let blobObj of section.blobs){
                    if(blobObj.ref.current && !blobObj.blob){
                        this.setState({ disableDownloadReport: true });
                        let debouncedFun = debounce(async () => {
                            this.setState({ disableDownloadReport: true });
                            await html2canvas(blobObj.ref.current).then(canvas => new Promise(resolve => canvas.toBlob(resolve))).then(blob => {
                                blobObj.blob = blob;
                            });
                            this.setState({ disableDownloadReport: false });
                            this.debouncedGeneratePdf();
                        }, 2500, true);
                        debouncedFun();
                    }
                }
            }
        }
    }, 100, true)
    

    render() {
        const TotalCount = this.state.status['Total'] ? this.state.status['Total'] : 1;
        const sentCount = this.state.status['Email Sent'] || this.state.status['SMS Sent'] || this.state.status['Message Sent'] || this.state.status['Call Initiated'] || TotalCount;
        // Overall Phish Risk Rate
        const linkRisk = Number(((this.state.status['Link Clicked'] * 100) / sentCount).toFixed(2));
        let { currentRisk, min, max, attackType } = this.state;
        currentRisk = (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? Math.floor(currentRisk) : Math.floor(linkRisk);
        const percentage = ((currentRisk - min) / (max - min)) * 100;
        const pointerPosition = `calc(${percentage}% - 0px)`;
        const filterableStatuses = {
            "Phishing": ["Email Sent", "Email Opened", "Link Clicked", "Data Submitted"],
            "Ransomware": ["Email Sent", "Email Opened", "Link Clicked", "System Hacked"],
            "Smishing": ["SMS Sent", "Link Clicked", "Data Submitted"],
            "Vishing": ["Call Initiated", "Call Picked", "Data Submitted"],
            "WhatsApp": ["Message Sent", "Link Clicked", "Data Submitted"],
            "Attachment": ["Email Sent", "Email Opened", "Attachment Opened"],
            "QRcode": ["Email Sent", "Email Opened", "QR Scanned", "Data Submitted"],
            "Telegram": ["Message Sent", "Link Clicked", "Data Submitted"],
            "Vishing-inbound": ["Email Sent", "Email Opened", "Call Received", "Data Submitted"],
            "WhatsApp-inbound": ["Email Sent", "Email Opened", "Link Clicked", "Data Submitted"]
        }

        //Link Cliked, QR Scanned, Call Received -> 80%
        //Data Submitted, System Hacked, Attachment Opened -> 100%
        const reportSectionList = [
            { key: 'campaign-summary', label: 'Campaign Summary' },
            { key: 'template-details', label: 'Template Details' },
            { key: 'key-metrics', label: 'Key Metrics' },
            { key: 'vulnerability-summary', label: 'Vulnerability Summary' },
            { key: 'department-wise-summary', label: 'Department Wise Summary' },
            { key: 'designation-wise-summary', label: 'Designation Wise Summary' },
            { key: 'location-wise-summary', label: 'Location Wise Summary' },
            { key: 'summary-and-conclusion', label: 'Summary & Conclusion' },
        ];

        const riskRateDescriptions = {
            "Phishing": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of emails sent.",
            "Smishing": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of SMS messages sent.",
            "Ransomware": "Phish Risk Rate is calculated by dividing the number of users whose systems were compromised by the total number of emails sent.",
            "Vishing": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of phone calls made.",
            "WhatsApp": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of WhatsApp messages sent.",
            "Attachment": "Phish Risk Rate is calculated by dividing the number of users who opened the attachment by the total number of emails sent.",
            "QRcode": "Phish Risk Rate is calculated by dividing the number of users who scanned the QR code and submitted their data by the total number of emails sent.",
            "Telegram": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of WhatsApp messages sent.",
            "Vishing-inbound": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of emails sent.",
            "WhatsApp-inbound": "Phish Risk Rate is calculated by dividing the number of users who submitted their data by the total number of emails sent."
        };
        const clickRateDescriptions = {
            "Phishing": "Link Click Rate is calculated by dividing the number of users who had clicked on a link by the total number of emails sent.",
            "Smishing": "Link Click Rate is calculated by dividing the number of users who had clicked on a link by the total number of SMS messages sent.",
            "WhatsApp": "Link Click Rate is calculated by dividing the number of users who had clicked on a link by the total number of WhatsApp messages sent.",
            "QRcode": "QR Scan Rate is calculated by dividing the number of users who had scanned the qr code by the total number of emails sent.",
            "Telegram": "Link Click Rate is calculated by dividing the number of users who had clicked on a link by the total number of WhatsApp messages sent.",
            "Vishing-inbound": "Link Click Rate is calculated by dividing the number of users who had called on an attacker number by the total number of emails sent.",
            "WhatsApp-inbound": "Link Click Rate is calculated by dividing the number of users who had clicked on a link by the total number of emails sent."
        };
        const filterableStatusesFunction = (attackType, targetInteractionType) => {
            let attackTypeKey = attackType;

            if(attackType === "Vishing" && targetInteractionType === "inbound"){
                attackTypeKey = "Vishing-inbound";
            } else if(attackType === "WhatsApp" && targetInteractionType === "inbound"){
                attackTypeKey = "WhatsApp-inbound";
            }
            return filterableStatuses[attackTypeKey];
        }
        const filterableStatusesAttackTypeLength = filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.length;
        const risk = (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? this.state.currentRisk : linkRisk;
        const mediumRiskThreshold = (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? (this.state.industryRisk) : 30;
        const lowRiskThreshold = (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? (this.state.industryRisk) : 30;
        const riskType = (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? "Phish Risk" : (this.state.attackType === "QRcode" ? "QR Scan" : "Link Click")

        // const showSection = (key) => this.state.reportSections[key];
        const showSection = (key) => this.state.reportSectionIds?.includes(key);


        return (
            <div className="content-wrap report-page-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">
                                    <a onClick={e => this.props.history.goBack()} className="bar_Icons mr-2"><ArrowBackSharpIcon className="btn-icon" />
                                    </a>Campaign Report</h4>
                            </div>
                        </div>

                        <div className="col-md-8 flexFilterButtons">
                            {this.state.latestSimulationExpiresOn && new Date(this.state.latestSimulationExpiresOn)>new Date() && 
                                <Button variant="secondary" type="button" className="mr-2" onClick={e => this.setState({ showSchedulerModal: true })}><DateRangeSharpIcon className="btn-icon"></DateRangeSharpIcon> Schedule</Button>
                            }
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    this.state.disableDownloadReport ? (
                                        <Tooltip id="bottom"> <span>Please wait</span>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip id="bottom" className="d-none" />
                                    )
                                }
                            >
                                <Button id='download-report-btn' style={{ cursor: this.state.disableDownloadReport ? 'not-allowed' : 'pointer', width: 'fit-content' }} variant="success" className="mr-2 executive-report-btn" onClick={() => { if (!this.state.disableDownloadReport) this.setState({ showSendReportToEmailsModal: true }) }} disabled={this.state.disableDownloadReport}>
                                    Send
                                </Button>
                            </OverlayTrigger>
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    this.state.disableDownloadReport ? (
                                        <Tooltip id="bottom"> <span>Please wait</span>
                                        </Tooltip>
                                    ) : (
                                        <Tooltip id="bottom" className="d-none" />
                                    )
                                }
                            >
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary" disabled={this.state.isReportGenerating || this.state.disableDownloadReport}>
                                        {this.state.isReportGenerating ?
                                            <Spinner loading={this.state.isReportGenerating}></Spinner> : "Download"
                                        }
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu style={{fontSize: '12px'}}>
                                        <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "en"}) }}>English Report</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "ar"}) }}>Arabic Report</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "id"}) }}>Bahasa Report</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </OverlayTrigger>

                        </div>
                    </div>
                </div>


                <div className='row m-0 report-page-body'>
                    <div className='col-md-3 addBorderRight'>
                        {/* <div className={`tableOfContentsSidebar${this.state.sidebarFixed ? ' sidebar-fixed' : ''}`}> */}
                        <div className={`tableOfContentsSidebar`}>

                            <h5><strong>Table of Contents</strong></h5>
                            <p>Select the content to be  added in the report:</p>
                            <div className="tableOfContentsForm">
                                <Form>
                                    <Form.Group>
                                        <div>
                                            {reportSectionList.map(section => (
                                                <Form.Check
                                                    key={section.key}
                                                    type="checkbox"
                                                    id={section.key}
                                                    label={section.label}
                                                    checked={this.state.reportSectionIds?.includes(section.key)}
                                                    onChange={e => {
                                                        let updatedIds = [];
                                                        if (e.target.checked) {
                                                            updatedIds = this.state.reportSectionIds?.includes(section.key)
                                                                ? this.state.reportSectionIds
                                                                : [...this.state.reportSectionIds, section.key];
                                                        } else {
                                                            updatedIds = this.state.reportSectionIds?.filter(id => id !== section.key);
                                                        }
                                                        this.updateExecutiveReportSection(updatedIds);
                                                        
                                                    }}
                                                    disabled={filterableStatusesAttackTypeLength === 0 || (section.key === 'campaign-summary')}
                                                />
                                            ))}
                                        </div>
                                    </Form.Group>
                                </Form>
                            </div>
                            
                        <div className="badge-note"><b>Note:</b> Only selected Table of Content section will appear in the preview and report. Your selection will be saved for this report.</div>
                        </div>

                    </div>
                    <div className='col-md-9 p-0 report-preview-scroll'>
                        <div className="exeReportWrapper" ref={this.reportRef}>
                            <div className="page-content">


                                {/* New Report Code */}
                                <div id="pdf-wrap">

                                    {/* Section 1: Campaign Summary */}

                                    {
                                        showSection('campaign-summary') && (
                                            <div className="pdf-card-wrap">
                                                <div className="heading">
                                                    <h5>Campaign Summary</h5>
                                                </div>
                                                <div className="card-body-wrap">
                                                    <Table className="borderless-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>Campaign Name</td>
                                                                <td>{this.state.campaignName}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Attack Vector</td>
                                                                <td><Badge bg="primary" className="custom-badge-info">{this.state.attackType}</Badge></td>
                                                            </tr>
                                                            
                                                            <tr>
                                                                <td>Start Date</td>
                                                                <td>{this.formatDate(this.state.fromDate)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>End Date</td>
                                                                <td>{this.formatDate(this.state.toDate)}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Total Users</td>
                                                                <td>{this.state.totalTargetsCount}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Groups</td>
                                                                <td>
                                                                    {this.state.details?.campaign?.campaign_groups?.filter(cg => cg?.group?.type !== "simulation-generated").map(cg => (
                                                                        <>
                                                                            <Badge bg="light" className="custom-badge-secondary">{cg.group?.name?.startsWith("ALL-Users-IN-COMPANY-") ? "all-users-tsat" : cg.group?.name} ({cg.group?.targetsCount})</Badge>{' '}
                                                                        </>
                                                                    ))}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>Campaign Status</td>
                                                                <td>{this.state.campaignStatus}</td>
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>


                                                {/* Section 2: Risk Overview */}
                                                {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment") ? (
                                                    <div className="pdf-card-wrap second-card-wrap">
                                                        <div className="card-body-wrap">
                                                            <div className="phish-risk-box">
                                                                <h6>
                                                                    <span className="span-color-red">Phish Risk Rate :</span> <span>{this.state.currentRisk}%</span>
                                                                </h6>
                                                                <Badge className={
                                                                    this.state.currentRisk >= (this.state.industryRisk)
                                                                        ? "custom-badge-danger"
                                                                        : (this.state.currentRisk < this.state.industryRisk
                                                                            ? "custom-badge-safe"
                                                                            : "custom-badge-moderate")
                                                                }>
                                                                    {this.state.currentRisk >= (this.state.industryRisk)
                                                                        ? "High Risk"
                                                                        : (this.state.currentRisk < this.state.industryRisk
                                                                            ? "Low Risk"
                                                                            : "Moderate Risk")}
                                                                </Badge>

                                                                <div className='mt-3' ref={this.phishRiskBarRef} style={{ padding: '0px 45px', marginLeft: '-40px', marginRight: '-40px' }}>
                                                                    <div className="gauge-container">
                                                                        {/* Gauge Value Indicator */}

                                                                        <div className="gauge-value-container" style={{ left: pointerPosition, marginTop: (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment" || this.state.attackType === "Ransomware") ? '0px' : '20px' }}>
                                                                            <div className="gauge-value">
                                                                                <div>Your Phish Risk Rate</div>
                                                                                <div>{this.state.currentRisk}%</div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Gauge Bar */}
                                                                        <div className="gauge-bar" style={{ position: "relative" }}>
                                                                            {/* Green Section (0-30%) */}
                                                                            <div className="gauge-section gauge-green" style={{ width: `${this.state.industryRisk}%` }}></div>
                                                                            <span className="gauge-label-mid" style={{ position: 'absolute', top: '20.1px', left: `${this.state.industryRisk - 1}%` }}>{this.state.industryRisk}</span>
                                                                            {/* <div className="gauge-section gauge-green"></div>
                                                                <div className="gauge-section gauge-green"></div> */}

                                                                            {/* Yellow Section (30-70%) */}
                                                                            {/* <div className="gauge-section gauge-yellow"></div> */}
                                                                            {/* <div className="gauge-section gauge-yellow" style={{ width: `${10}%` }}></div> */}
                                                                            {/* <span className="gauge-label-mid-high" style={{position: 'absolute', top: '20.1px', left: `${this.state.industryRisk+10-1}%`}}>{this.state.industryRisk+10}</span> */}
                                                                            {/* <div className="gauge-section gauge-yellow"></div>
                                                                <div className="gauge-section gauge-yellow"></div> */}

                                                                            {/* Red Section (70-100%) */}
                                                                            <div className="gauge-section gauge-red" style={{ flex: 1 }}></div>
                                                                            {/* <div className="gauge-section gauge-red"></div>
                                                                <div className="gauge-section gauge-red"></div> */}
                                                                        </div>

                                                                        {/* Scale Labels */}
                                                                        <div className="gauge-labels">
                                                                            <span className="gauge-label-min">{min}</span>
                                                                            {/* <span className="gauge-label-mid">{this.state.industryRisk}</span>
                                                                <span className="gauge-label-mid-high">{this.state.industryRisk+mediumScore}</span> */}
                                                                            <span className="gauge-label-max">{max}</span>
                                                                        </div>

                                                                        {/* Legend */}
                                                                        {/* <div className="gauge-legend mt-3">
                                                                <div className="legend-item">
                                                                <div className="legend-color legend-green"></div>
                                                                <div className="legend-text">Low</div>
                                                                </div>
                                                                <div className="legend-item">
                                                                <div className="legend-color legend-red"></div>
                                                                <div className="legend-text">High</div>
                                                                </div>
                                                            </div> */}
                                                                    </div>
                                                                    <div className="gauge-container mt-4">
                                                                        {/* Gauge Value Indicator */}
                                                                        <div className="gauge-value-container" style={{ left: `${this.state.industryRisk}%`, marginTop: (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType==="outbound")|| this.state.attackType === "Attachment" || this.state.attackType === "Ransomware") ? '0px' : '20px' }}>
                                                                            <div className="gauge-value">
                                                                                <div>Industry Phish Risk Rate</div>
                                                                                <div>{this.state.industryRisk}%</div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Gauge Bar */}
                                                                        <div className="gauge-bar" style={{ position: "relative" }}>
                                                                            {/* Green Section (0-30%) */}
                                                                            <div className="gauge-section gauge-green" style={{ width: `${this.state.industryRisk}%` }}></div>
                                                                            <span className="gauge-label-mid" style={{ position: 'absolute', top: '20.1px', left: `${this.state.industryRisk - 1}%` }}>{this.state.industryRisk}</span>
                                                                            {/* <div className="gauge-section gauge-green"></div>
                                                                <div className="gauge-section gauge-green"></div> */}

                                                                            {/* Yellow Section (30-70%) */}
                                                                            {/* <div className="gauge-section gauge-yellow"></div> */}
                                                                            {/* <div className="gauge-section gauge-yellow" style={{ width: `${10}%` }}></div> */}
                                                                            {/* <span className="gauge-label-mid-high" style={{position: 'absolute', top: '20.1px', left: `${this.state.industryRisk+10-1}%`}}>{this.state.industryRisk+10}</span> */}
                                                                            {/* <div className="gauge-section gauge-yellow"></div>
                                                                <div className="gauge-section gauge-yellow"></div> */}

                                                                            {/* Red Section (70-100%) */}
                                                                            <div className="gauge-section gauge-red" style={{ flex: 1 }}></div>
                                                                            {/* <div className="gauge-section gauge-red"></div>
                                                                <div className="gauge-section gauge-red"></div> */}
                                                                        </div>

                                                                        {/* Scale Labels */}
                                                                        <div className="gauge-labels">
                                                                            <span className="gauge-label-min">{min}</span>
                                                                            {/* <span className="gauge-label-mid">{this.state.industryRisk}</span>
                                                                <span className="gauge-label-mid-high">{this.state.industryRisk+mediumScore}</span> */}
                                                                            <span className="gauge-label-max">{max}</span>
                                                                        </div>

                                                                        {/* Legend */}
                                                                        <div className="gauge-legend mt-3">
                                                                            <div className="legend-item">
                                                                                <div className="legend-color legend-green"></div>
                                                                                <div className="legend-text">Low</div>
                                                                            </div>
                                                                            {/* <div className="legend-item">
                                                                <div className="legend-color legend-yellow"></div>
                                                                <div className="legend-text">{this.state.industryRisk} - {this.state.industryRisk+10}% Medium</div>
                                                                </div> */}
                                                                            <div className="legend-item">
                                                                                <div className="legend-color legend-red"></div>
                                                                                <div className="legend-text">High</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="phishing-box">

                                                                <div className='boxHeading'>
                                                                    <h6>What is {riskType} Rate</h6>
                                                                    <p>{riskType === "Phish Risk" ? riskRateDescriptions[this.state.attackType] : clickRateDescriptions[this.state.attackType]}</p>
                                                                </div>

                                                                <div className='boxHeading mt-4'>
                                                                    <h6>What is Industry Phish Risk Rate</h6>
                                                                    <p>Industry phish risk rate shows the average phishing risk in your industry segment, so you can compare your own
                                                                        phish risk with the industry average.</p>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>

                                                ) : (
                                                    <div className="pdf-card-wrap second-card-wrap">
                                                        <div className="card-body-wrap">
                                                            <div className="phish-risk-box">
                                                                <h6>
                                                                    <span className="span-color-red">{riskType} Rate :</span> <span>{linkRisk}%</span>
                                                                </h6>
                                                                <Badge className={
                                                                    linkRisk >= (30)
                                                                        ? "custom-badge-danger"
                                                                        : (linkRisk < 30
                                                                            ? "custom-badge-safe"
                                                                            : "custom-badge-moderate")
                                                                }>
                                                                    {linkRisk >= 30
                                                                        ? "High Risk"
                                                                        : (linkRisk < 30
                                                                            ? "Low Risk"
                                                                            : "Moderate Risk")}
                                                                </Badge>

                                                                <div className='mt-3' ref={this.phishRiskBarRef} style={{ padding: '0px 45px', marginLeft: '-40px', marginRight: '-40px' }}>
                                                                    <div className="gauge-container">
                                                                        {/* Gauge Value Indicator */}
                                                                        <div className="gauge-value-container" style={{ left: pointerPosition }}>
                                                                            <div className="gauge-value">
                                                                                <div>Your {riskType} Rate</div>
                                                                                <div>{linkRisk}%</div>
                                                                            </div>
                                                                        </div>

                                                                        {/* Gauge Bar */}
                                                                        <div className="gauge-bar" style={{ position: "relative" }}>
                                                                            {/* Green Section (0-30%) */}
                                                                            <div className="gauge-section gauge-green" style={{ width: `30%` }}></div>
                                                                            <div className="gauge-section gauge-red" style={{ flex: 1 }}></div>
                                                                        </div>

                                                                        {/* Scale Labels */}
                                                                        <div className="gauge-labels">
                                                                            <span className="gauge-label-min">{min}</span>
                                                                            <span className="gauge-label-mid" style={{ marginRight: '37.5%' }}>{30}</span>
                                                                            <span className="gauge-label-max">{max}</span>
                                                                        </div>
                                                                        <div className="gauge-legend mt-3">
                                                                            <div className="legend-item">
                                                                                <div className="legend-color legend-green"></div>
                                                                                <div className="legend-text">Low</div>
                                                                            </div>
                                                                            <div className="legend-item">
                                                                                <div className="legend-color legend-red"></div>
                                                                                <div className="legend-text">High</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div className="phishing-box">
                                                                <div className='boxHeading'>
                                                                    <h6>What is {riskType} Rate</h6>
                                                                    <p>{riskType === "Phish Risk" ? riskRateDescriptions[this.state.attackType] : clickRateDescriptions[this.state.attackType]}</p>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    }



                                    {/* Section 2: Template Details */}

                                    {
                                        showSection('template-details') && (
                                            (this.state.details?.assign_simulation_templates?.length > 1)
                                              ? this.renderMultiTemplateDetails()
                                              : (
                                            <div className="pdf-card-wrap">
                                                <div className="heading">
                                                    <h5>Template Details</h5>
                                                </div>
                                                <div className="card-body-wrap">
                                                    <Table className="borderless-table">
                                                        <tbody>
                                                            <tr>
                                                                <td>Template Name :</td>
                                                                <td>{this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.name + ' ')}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Template Category :</td>
                                                                <td>{this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.category?.name + ' ')}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Language:</td>
                                                                <td>{this.state.details?.assign_simulation_templates?.map(at => at?.campaign_template?.language?.name + ' ')}</td>
                                                            </tr>
                                                            <tr>
                                                                <td>Type of Simulation :</td>
                                                                <td>{this.state.details?.simulation_type?.name}</td>
                                                            </tr>
                                                            {!(attackType === "Vishing" && this.state.targetInteractionType === "outbound") && this.state.attackType !== "Attachment" && this.state.attackType !== "Ransomware" &&
                                                                <tr>
                                                                    <td>Credential Harvesting :</td>
                                                                    <td>
                                                                        <Badge
                                                                            bg="primary"
                                                                            className={this.isAssignTemplatesCredentialHarvestingEnabled() ? "custom-badge-success" : "custom-badge-danger"}
                                                                        >
                                                                            {this.isAssignTemplatesCredentialHarvestingEnabled() ? "Yes" : "No"}
                                                                        </Badge>
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                {!(attackType === "Vishing" && this.state.targetInteractionType === "outbound") &&
                                                    <>
                                                        {/* Section 4: Email Template */}
                                                        {(attackType === "Attachment" || attackType === "Ransomware" || attackType === "Phishing" || attackType === "QRcode" || (attackType === "Vishing" && this.state.targetInteractionType === "inbound") || (attackType === "WhatsApp" && this.state.targetInteractionType === "inbound")) ?
                                                            <div className="pdf-card-wrap">
                                                                <div className="card-body-wrap">
                                                                    <div className="email-template-box">
                                                                        <h5>Email Template</h5>
                                                                        <p><span>Subject: </span> {this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.template?.subject}</p>
                                                                        <p><span>Attacker Profile:</span> {this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.sender?.from_address}</p>
                                                                        <div className="mt-4">
                                                                            {/* <h6>(Image)</h6> */}
                                                                            <img style={{ maxWidth: '100%' }} src={this.state.details.templatePath} alt='Template image'></img>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div> : (

                                                                this.state.attackType === "WhatsApp" || this.state.attackType === "Telegram" || this.state.attackType === "Smishing" ?
                                                                    <div className="pdf-card-wrap">
                                                                        <div className="card-body-wrap">
                                                                            <div className="email-template-box">
                                                                                <h5>Message Template</h5>
                                                                                <div className="mt-4">
                                                                                    {/* <h6>(Image)</h6> */}
                                                                                    <img style={{ maxWidth: '100%' }} src={this.state.details.templatePath} alt='Template image'></img>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div> : ""
                                                            )
                                                        }
                                                        {this.state.attackType !== "Vishing" && !(this.state.attackType === "WhatsApp" && this.state.targetInteractionType==="inbound") &&
                                                            <>
                                                            {/* Section 5: Landing Page */}
                                                            {(this.state.attackType === "Ransomware" || this.state.credentialHarvesting) && this.state.attackType !== "Attachment" &&
                                                                <div className="pdf-card-wrap">
                                                                    <div className="card-body-wrap">
                                                                        <div className="email-template-box">
                                                                            <h5>Landing Page</h5>
                                                                            <p>
                                                                                <span>Url: </span>{this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.landing_url}
                                                                                {/* Capture flags only for vectors that actually offer credential
                                                                                    capture (mirrors supports-credential-capture() in main.typ) —
                                                                                    Ransomware has a landing page but no capture option. */}
                                                                                {!["Vishing", "Attachment", "Ransomware"].includes(this.state.attackType) && (
                                                                                    <>
                                                                                        , <span>Capture Credentials:</span>
                                                                                        <span className={this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_credentials == 1 ? "custom-badge-success badge" : "custom-badge-danger badge"}>
                                                                                            {this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_credentials == 1 ? "Yes" : "No"}
                                                                                        </span>,
                                                                                        <span>Capture Password:</span>
                                                                                        <span className={this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_passwords == 1 ? "custom-badge-success badge" : "custom-badge-danger badge"}>
                                                                                            {this.state.details?.assign_simulation_templates?.[0]?.campaign_template?.page?.capture_passwords == 1 ? "Yes" : "No"}
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </p>
                                                                            <div className="mt-4">
                                                                                <img style={{ maxWidth: '100%' }} src={this.state.details.pagePath} alt='Landing page'></img>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }

                                                            {/* Section 6: Awareness Page */}
                                                            {this.state.attackType !== "Ransomware" && !(this.state.attackType === "WhatsApp" && this.state.targetInteractionType==="inbound") && (
                                                                <div className="pdf-card-wrap">
                                                                    <div className="card-body-wrap">
                                                                        <div className="email-template-box">
                                                                            <h5>Awareness Page</h5>
                                                                            <p><span>Url: </span>{this.state.details.awarenessUrl}</p>
                                                                            <div className="mt-4">
                                                                                <img style={{ maxWidth: '100%' }} src={this.state.details.awarenessPath} alt='Awareness page'></img>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                            </>
                                                        }

                                                    </>
                                                }
                                            </div>
                                              )
                                        )
                                    }



                                    {/* Section 3: Key Metrics */}
                                    {
                                        showSection('key-metrics') && (
                                            <div className="pdf-card-wrap" >
                                                <div className="heading">
                                                    <h5>Key Metrics</h5>
                                                </div>
                                                <div className="card-body-wrap" >
                                                    <div className="pie-chard-box mb-4">
                                                        <div>
                                                            <div className="row text-center justify-content-around mb-4" ref={this.keyMetricsRef}>
                                                                <div>&nbsp;</div>
                                                                {'Email Sent' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <EmailSend
                                                                            value={this.state.status['Email Sent']}
                                                                            percent={((this.state.status['Email Sent'] * 100) / TotalCount).toFixed(2)}
                                                                        ></EmailSend>
                                                                        <span className="data-label-chart">Email Send</span>
                                                                    </div> : ''
                                                                }{'SMS Sent' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <SMSSend
                                                                            value={this.state.status['SMS Sent']}
                                                                            percent={((this.state.status['SMS Sent'] * 100) / TotalCount).toFixed(2)}
                                                                        ></SMSSend>
                                                                        <span className="data-label-chart">SMS Send</span>
                                                                    </div> : ''
                                                                }{'Message Sent' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <MessageSent
                                                                            value={this.state.status['Message Sent']}
                                                                            percent={((this.state.status['Message Sent'] * 100) / TotalCount).toFixed(2)}
                                                                        ></MessageSent>
                                                                        <span className="data-label-chart">Message Send</span>
                                                                    </div> : ''
                                                                }{'Call Initiated' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <CallInitiated
                                                                            value={this.state.status['Call Initiated']}
                                                                            percent={((this.state.status['Call Initiated'] * 100) / TotalCount).toFixed(2)}
                                                                        ></CallInitiated>
                                                                        <span className="data-label-chart">Call Initiated</span>
                                                                    </div> : ''
                                                                }{'Call Picked' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <CallPicked
                                                                            value={this.state.status['Call Picked']}
                                                                            percent={((this.state.status['Call Picked'] * 100) / TotalCount).toFixed(2)}
                                                                        ></CallPicked>
                                                                        <span className="data-label-chart">Call Picked</span>
                                                                    </div> : ''
                                                                }{'Email Opened' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <EmailOpened
                                                                            value={this.state.status['Email Opened']}
                                                                            percent={((this.state.status['Email Opened'] * 100) / TotalCount).toFixed(2)}
                                                                        ></EmailOpened>
                                                                        <span className="data-label-chart">Email Opened</span>
                                                                    </div> : ''
                                                                }{'Link Clicked' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <LinkClicked
                                                                            value={this.state.status['Link Clicked']}
                                                                            percent={((this.state.status['Link Clicked'] * 100) / TotalCount).toFixed(2)}
                                                                            label={attackType === "QRcode" ? "QR Scanned" : "Link Clicked"}
                                                                        ></LinkClicked>
                                                                        <span className="data-label-chart">Link Clicked</span>
                                                                    </div> : ''
                                                                }
                                                                {'Call Received' in this.state.status ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <CallReceived
                                                                            value={this.state.status['Call Received']}
                                                                            percent={((this.state.status['Call Received'] * 100) / TotalCount).toFixed(2)}
                                                                            label={"Call Received"}
                                                                        ></CallReceived>
                                                                        <span className="data-label-chart">Call Received</span>
                                                                    </div> : ''
                                                                }
                                                                {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") &&
                                                                    <>
                                                                        {'Data Submitted' in this.state.status ?
                                                                            <div className="col-sm-2 p-0">
                                                                                <DataSubmitted
                                                                                    value={this.state.status['Data Submitted']}
                                                                                    percent={((this.state.status['Data Submitted'] * 100) / TotalCount).toFixed(2)}
                                                                                ></DataSubmitted>
                                                                                <span className="data-label-chart">Data Submitted</span>
                                                                            </div> : ''
                                                                        }{'Attachment Opened' in this.state.status ?
                                                                            <div className="col-sm-2 p-0">
                                                                                <AttachmentOpened
                                                                                    value={this.state.status['Attachment Opened']}
                                                                                    percent={((this.state.status['Attachment Opened'] * 100) / TotalCount).toFixed(2)}
                                                                                ></AttachmentOpened>
                                                                                <span className="data-label-chart">Attachment Opened</span>
                                                                            </div> : ''
                                                                        }{'System Hacks' in this.state.status ?
                                                                            <div className="col-sm-2 p-0">
                                                                                <SystemHack
                                                                                    value={this.state.status['System Hacks']}
                                                                                    percent={((this.state.status['System Hacks'] * 100) / TotalCount).toFixed(2)}
                                                                                ></SystemHack>
                                                                                <span className="data-label-chart">System Hacks</span>
                                                                            </div> : ''
                                                                        }
                                                                    </>
                                                                }
                                                                {'Replied' in this.state.status && this.state.isRepliedCampaign ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <Replied
                                                                            value={this.state.status['Replied']}
                                                                            percent={((this.state.status['Replied'] * 100) / TotalCount).toFixed(2)}
                                                                        ></Replied>
                                                                        <span className="data-label-chart">Replied</span>
                                                                    </div> : ''
                                                                }
                                                                {'Email Reported' in this.state.status && this.state.status['Email Reported'] > 0 && (this.state.attackType === "Phishing" || this.state.attackType === "Ransomware" || this.state.attackType === "Attachment" || this.state.attackType === "QRcode" || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "inbound") || (this.state.attackType === "WhatsApp" && this.state.targetInteractionType === "inbound")) ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <EmailReported
                                                                            value={this.state.status['Email Reported']}
                                                                            percent={((this.state.status['Email Reported'] * 100) / TotalCount).toFixed(2)}
                                                                        ></EmailReported>
                                                                        <span className="data-label-chart">Email Reported</span>
                                                                    </div> : ''
                                                                }
                                                                {('Error' in this.state.status && this.state.status['Error'] > 0) ?
                                                                    <div className="col-sm-2 p-0">
                                                                        <Error
                                                                            value={this.state.status['Error']}
                                                                            percent={((this.state.status['Error'] * 100) / TotalCount).toFixed(2)}
                                                                        ></Error>
                                                                        <span className="data-label-chart">Error</span>
                                                                    </div> : ''
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="key-metrics-table">
                                                        <Table className="metrics-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Metric</th>
                                                                    <th className='th-center'>Value</th>
                                                                    <th className='th-center'>Percentage</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {('Email Sent' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Emails Sent</td>
                                                                        <td className='td-center'>{this.state.status['Email Sent']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Email Sent'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('SMS Sent' in this.state.status) &&
                                                                    <tr>
                                                                        <td>SMS Sent</td>
                                                                        <td className='td-center'>{this.state.status['SMS Sent']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['SMS Sent'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Message Sent' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Message Sent</td>
                                                                        <td className='td-center'>{this.state.status['Message Sent']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Message Sent'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Call Initiated' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Call Initiated</td>
                                                                        <td className='td-center'>{this.state.status['Call Initiated']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Call Initiated'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Call Picked' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Call Picked</td>
                                                                        <td className='td-center'>{this.state.status['Call Picked']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Call Picked'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Email Opened' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Emails Opened</td>
                                                                        <td className='td-center'>{this.state.status['Email Opened']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Email Opened'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Link Clicked' in this.state.status) &&
                                                                    <tr>
                                                                        <td>{attackType === "QRcode" ? "QR Scanned" : "Links Clicked"}</td>
                                                                        <td className='td-center'>{this.state.status['Link Clicked']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Link Clicked'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Call Received' in this.state.status) &&
                                                                    <tr>
                                                                        <td>Call Received</td>
                                                                        <td className='td-center'>{this.state.status['Call Received']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Call Received'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") &&
                                                                    <>
                                                                        {('Data Submitted' in this.state.status) &&
                                                                            <tr>
                                                                                <td>Data Submitted</td>
                                                                                <td className='td-center'>{this.state.status['Data Submitted']}</td>
                                                                                <td className="td-center">{Number(((this.state.status['Data Submitted'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                            </tr>
                                                                        }
                                                                        {('Attachment Opened' in this.state.status) &&
                                                                            <tr>
                                                                                <td>Attachment Opened</td>
                                                                                <td className='td-center'>{this.state.status['Attachment Opened']}</td>
                                                                                <td className="td-center">{Number(((this.state.status['Attachment Opened'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                            </tr>
                                                                        }
                                                                        {('System Hacks' in this.state.status) &&
                                                                            <tr>
                                                                                <td>System Hacks</td>
                                                                                <td className='td-center'>{this.state.status['System Hacks']}</td>
                                                                                <td className="td-center">{Number(((this.state.status['System Hacks'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                            </tr>
                                                                        }
                                                                    </>
                                                                }
                                                                {('Replied' in this.state.status && this.state.isRepliedCampaign) &&
                                                                    <tr>
                                                                        <td>Replied</td>
                                                                        <td className='td-center'>{this.state.status['Replied']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Replied'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Email Reported' in this.state.status && this.state.status['Email Reported'] > 0 &&
                                                                    ((['Phishing', 'Ransomware', 'Attachment', 'QRcode'].includes(this.state.attackType)) || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "inbound") || (this.state.attackType === "WhatsApp" && this.state.targetInteractionType === "inbound"))) &&
                                                                    <tr>
                                                                        <td>Email Reported</td>
                                                                        <td className='td-center'>{this.state.status['Email Reported']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Email Reported'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                                {('Error' in this.state.status) && this.state.status['Error'] > 0 &&
                                                                    <tr>
                                                                        <td>Error</td>
                                                                        <td className='td-center'>{this.state.status['Error']}</td>
                                                                        <td className="td-center">{Number(((this.state.status['Error'] * 100) / TotalCount).toFixed(2))}%</td>
                                                                    </tr>
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </div>


                                                    <div className="set-border">
                                                        <div className="key-metrics-average-time">
                                                            <div className="row" style={{ marginBottom: (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") ? "70px" : "8px" }}>
                                                                {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") &&
                                                                    <div className="col-md-4 ">
                                                                        <div className="metric-container border-end">
                                                                            <h6 className="metric-title">Minimum Breach Time</h6>
                                                                            <div className="metric-value text-danger">{this.state.breachTime}</div>
                                                                        </div>
                                                                    </div>
                                                                }
                                                                <div className="col-md-4">
                                                                    <div className="metric-container">
                                                                        <h6 className="metric-title">Average EVS</h6>
                                                                        <div className="metric-value text-danger">{this.state.averageEvsScore}%</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") &&
                                                                <div className="mt-15">
                                                                    <div className="col-md-10 mx-auto">
                                                                        <div className="timeline-container">
                                                                            <div className="timeline-track">
                                                                                <div className="timeline-progress">
                                                                                    <div className="timeline-segment bg-success" style={{ width: '40%' }}></div>
                                                                                    {/* <div className="timeline-segment bg-warning" style={{ width: '20%' }}></div>
                                                                <div className="timeline-segment bg-orange" style={{ width: '20%' }}></div>
                                                                <div className="timeline-segment bg-danger" style={{ width: '20%' }}></div> */}
                                                                                    {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.map((status, index) => (
                                                                                        (index > 0 && <div className={`timeline-segment ${index === filterableStatusesAttackTypeLength - 1
                                                                                            ? "bg-danger"
                                                                                            : index === filterableStatusesAttackTypeLength - 2
                                                                                                ? "bg-orange"
                                                                                                : "bg-warning"
                                                                                            }`} style={{ width: 60 / (filterableStatusesAttackTypeLength - 1) + "%" }}></div>)
                                                                                    ))}
                                                                                </div>

                                                                                <div className="timeline-points">
                                                                                    <div className="timeline-point point-success" style={{ left: '0%' }}>
                                                                                        <div className="point-circle"></div>
                                                                                        <div className={`point-label`}>Attack Launched</div>
                                                                                    </div>
                                                                                    {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.map((status, index) => (
                                                                                        <div className={`timeline-point ${(index == filterableStatusesAttackTypeLength - 1) ? "point-danger" :
                                                                                            index == filterableStatusesAttackTypeLength - 2 ? "point-orange" : "point-warning"
                                                                                            }`} style={{ left: `${40 + (index * 60 / (filterableStatusesAttackTypeLength - 1))}%` }}>
                                                                                            <div className="point-circle"></div>
                                                                                            <div className={`point-label`}>{status}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>

                                                                            <div className="breach-time-indicator" >
                                                                                <div className="breach-time-bar">

                                                                                    <div className="breach-time-label" style={{ top: "25%" }}>Breach Time</div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>

                                                        <div className="average-time-content">
                                                            {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") &&
                                                                <div className="average-time-box">
                                                                    <div className='boxHeading'>
                                                                        <h6>What is Breach Time?</h6>
                                                                        <p>
                                                                            Time to Breach represents the interval between {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType) && filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)[0]} and {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType) && filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)[filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.length - 1]} during the campaign,
                                                                            indicating user response time under attack conditions.
                                                                        </p>

                                                                    </div>

                                                                </div>
                                                            }


                                                            <div className="average-time-box">
                                                                <div className='boxHeading'>
                                                                    <h6>What is EVS?</h6>
                                                                    <p>
                                                                        The Employee Vulnerability Score (EVS) measures how susceptible an employee is to threats like phishing, based on their
                                                                        behavior during simulated campaign.
                                                                    </p>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        )
                                    }


                                    {/* Section 4: Vulnerability Summary */}
                                    {
                                        showSection('vulnerability-summary') && (
                                            <div className="pdf-card-wrap">
                                                <div className="heading">
                                                    <h5>Vulnerability Summary</h5>
                                                </div>
                                                <div className="card-body-wrap">
                                                    <div className="key-metrics-table vulnerability-summary-table set-border">
                                                        <div className="card-heading">
                                                            <h5>Most Vulnerable Employees <span>(as per Employee Vulnerability Score)</span></h5>
                                                        </div>

                                                        <Table className=" metrics-table">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Designation</th>
                                                                    <th>Department</th>
                                                                    <th>Location</th>
                                                                    {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") ?
                                                                        <th>Breach Time</th> :
                                                                        (this.state.attackType === "QRcode") ? <th>Scan Time</th> :
                                                                            <th>Link Click Time</th>
                                                                    }
                                                                    <th>EVS</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {(this.state.mostVulnerableEmployees?.length > 0) ? this.state.mostVulnerableEmployees.map((employee, index) => (
                                                                    <tr>
                                                                        <td className='summary-info'>
                                                                            <h6>{employee.firstname} {employee.lastname}</h6>
                                                                            <p>{employee.email}</p>
                                                                        </td>
                                                                        <td>{employee.position || '---'}</td>
                                                                        <td>{employee.department || '---'}</td>
                                                                        <td>{employee.location || '---'}</td>
                                                                        {(this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment") ?
                                                                            <td className='td-color'>{this.formatDuration(employee.breachTime)}</td> :
                                                                            <td className='td-color'>{this.formatDuration(employee.linkClickTime)}</td>

                                                                        }
                                                                        <td className='td-color'>{employee.evsScore}%</td>
                                                                    </tr>

                                                                )) : <span style={{ padding: '5px' }}>No data found</span>}
                                                            </tbody>
                                                        </Table>
                                                    </div>

                                                    <div className="key-metrics-table set-border">
                                                        <div className="card-heading">
                                                            <h5>Most Vulnerable Departments <span>(as per Employee Vulnerability Score)</span></h5>
                                                            <div ref={this.mvDepBarRef}>
                                                                <NewBreachReportGraph dataArray={(this.state.departmentWisePieChart || [])?.slice(0, 5).filter(el => el.value > 0)} chartId="department-breach-chart">
                                                                </NewBreachReportGraph>

                                                                <div className='label_wrapper'>
                                                                    <p><b>X-axis:</b> Department Name</p>
                                                                    <p><b>Y-axis:</b> Average EVS of all users in the department (%)</p>
                                                                </div>

                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="key-metrics-table set-border">
                                                        <div className="card-heading">
                                                            <h5>Most Vulnerable Locations <span>(as per Employee Vulnerability Score)</span></h5>
                                                            <div className='mb-4' ref={this.mvLocBarRef}>
                                                                <NewBreachReportGraph dataArray={(this.state.locationWisePieChart || [])?.slice(0, 5).filter(el => el.value > 0)} chartId="location-breach-chart">
                                                                </NewBreachReportGraph>
                                                                <div className='label_wrapper'>
                                                                    <p><b>X-axis:</b> Location Name</p>
                                                                    <p><b>Y-axis:</b> Average EVS of all users of a location (%)</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className="key-metrics-table set-border">
                                                        <div className="card-heading">
                                                            <h5>Most Vulnerable Designations <span>(as per Employee Vulnerability Score)</span></h5>
                                                            <div className='mb-4' ref={this.mvDesBarRef}>
                                                                <NewBreachReportGraph dataArray={((this.state.designationWisePieChart || []).slice(0, 5).filter(el => el.value > 0))} chartId="designation-breach-chart">
                                                                </NewBreachReportGraph>

                                                                <div className='label_wrapper'>
                                                                    <p><b>X-axis:</b> Designation Name</p>
                                                                    <p><b>Y-axis:</b> Average EVS of all users by designation (%)</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        )
                                    }



                                    {/* Section 5: Department Wise Summary */}
                                    {
                                        showSection('department-wise-summary') && (
                                            <div className="pdf-card-wrap">
                                                <div className="heading">
                                                    <h5>Department Wise Summary <span>(as per Employee Vulnerability Score)</span></h5>
                                                </div>


                                                <div className='mb-4' ref={this.depWiseSummaryPieRef}>
                                                    {<SumarryReportGraph dataArray={((this.state.departmentWisePieChart || []).map(data => {
                                                        let trimedLabel = data.label.slice(0, 20);
                                                        if(trimedLabel.length < data.label.length){
                                                            trimedLabel = trimedLabel + '...';
                                                        }
                                                        return ({label: trimedLabel, value: data.value})
                                                    }) || [])} chartId="department-wise-pie" />}
                                                    {(this.state.departmentWisePieChart || [])?.length > 30 &&
                                                        <p style={{ textAlign: 'center', fontSize: '12px' }}>Note: The graph list is too large to display. Data is visible only up to 30 entries.</p>
                                                    }
                                                </div>

                                                <div>
                                                    <Table className="metrics-table ">
                                                        <thead>
                                                            <tr>
                                                                <th>Department</th>
                                                                {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.map((dw, index) => (
                                                                    (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment" || this.state.attackType === "Ransomware" || (!this.state.credentialHarvesting && index < filterableStatusesAttackTypeLength - 1)) && <th>{dw}</th>
                                                                ))}
                                                                <th>EVS</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                            {this.state.departmentWiseSummary?.map(dw =>
                                                                <tr>
                                                                    <td >
                                                                        {dw.department}
                                                                    </td>
                                                                    {dw.data?.map(d => (
                                                                        <td className={`${d.message === "EVS" ? 'td-color' : ""}`}>{(d.count || d.count == 0) ? d.count : "---"}</td>
                                                                    ))}
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </Table>
                                                </div>


                                            </div>

                                        )
                                    }



                                    {/* Section 6: Designation Wise Summary */}

                                    {showSection('designation-wise-summary') && (
                                        <div className="pdf-card-wrap">
                                            <div className="heading">
                                                <h5>Designation Wise Summary <span>(as per Employee Vulnerability Score)</span></h5>
                                            </div>


                                            <div className='mb-4' ref={this.desWiseSummaryPieRef}>
                                                {<SumarryReportGraph dataArray={((this.state.designationWisePieChart || []).map(data => {
                                                    let trimedLabel = data.label.slice(0, 20);
                                                    if(trimedLabel.length < data.label.length){
                                                        trimedLabel = trimedLabel + '...';
                                                    }
                                                    return ({label: trimedLabel, value: data.value})
                                                }) || [])?.slice(0, 30)} chartId="designation-wise-pie" />}
                                                {(this.state.designationWisePieChart || [])?.length > 30 &&
                                                    <p style={{ textAlign: 'center', fontSize: '12px' }}>Note: The graph list is too large to display. Data is visible only up to 30 entries.</p>
                                                }
                                            </div>

                                            <div>
                                                <Table className="metrics-table ">
                                                    <thead>
                                                        <tr>
                                                            <th>Designation</th>
                                                            {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.map((dw, index) => (
                                                                (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment" || this.state.attackType === "Ransomware" || (!this.state.credentialHarvesting && index < filterableStatusesAttackTypeLength - 1)) && <th>{dw}</th>
                                                            ))}
                                                            <th>EVS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {this.state.designationWiseSummary?.map(dw =>
                                                            <tr>
                                                                <td >
                                                                    {dw.designation}
                                                                </td>
                                                                {dw.data?.map(d => (
                                                                    <td className={`${d.message === "EVS" ? 'td-color' : ""}`}>{(d.count || d.count == 0) ? d.count : "---"}</td>
                                                                ))}
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>


                                        </div>

                                    )
                                    }



                                    {/* Section 6: Location Wise Summary */}

                                    {showSection('location-wise-summary') && (
                                        <div className="pdf-card-wrap">
                                            <div className="heading">
                                                <h5>Location Wise Summary <span>(as per Employee Vulnerability Score)</span></h5>
                                            </div>


                                            <div className='mb-4' ref={this.locWiseSummaryPieRef}>
                                                {<SumarryReportGraph dataArray={((this.state.locationWisePieChart || []).map(data => {
                                                    let trimedLabel = data.label.slice(0, 20);
                                                    if(trimedLabel.length < data.label.length){
                                                        trimedLabel = trimedLabel + '...';
                                                    }
                                                    return ({label: trimedLabel, value: data.value})
                                                }) || [])?.slice(0, 30)} chartId="location-wise-pie" />}
                                                {(this.state.locationWisePieChart || [])?.length > 30 &&
                                                    <p style={{ textAlign: 'center', fontSize: '12px' }}>Note: The graph list is too large to display. Data is visible only up to 30 entries.</p>
                                                }
                                            </div>

                                            <div>
                                                <Table className=" metrics-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Location</th>
                                                            {filterableStatusesFunction(this.state.attackType, this.state.targetInteractionType)?.map((dw, index) => (
                                                                (this.state.credentialHarvesting || (this.state.attackType === "Vishing" && this.state.targetInteractionType === "outbound") || this.state.attackType === "Attachment" || this.state.attackType === "Ransomware" || (!this.state.credentialHarvesting && index < filterableStatusesAttackTypeLength - 1)) && <th>{dw}</th>
                                                            ))}
                                                            <th>EVS</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {this.state.locationWiseSummary?.map(dw =>
                                                            <tr>
                                                                <td >
                                                                    {dw.location}
                                                                </td>
                                                                {dw.data?.map(d => (
                                                                    <td className={`${d.message === "EVS" ? 'td-color' : ""}`}>{(d.count || d.count == 0) ? d.count : "---"}</td>
                                                                ))}
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </Table>
                                            </div>


                                        </div>

                                    )
                                    }



                                    {/* Section 8: Summary & Conclusion */}

                                    {
                                        showSection('summary-and-conclusion') && (
                                            risk >= mediumRiskThreshold ?
                                                (<div className="pdf-card-wrap mb-0">
                                                    <div className="heading">
                                                        <h5>Summary & Conclusion</h5>
                                                    </div>
                                                    <div className="card-body-wrap set-border mb-4">
                                                        <div className="summary-box">
                                                            <p>A High {riskType} Rate is a clear warning sign that your organization is highly susceptible to phishing threats. This represents a serious vulnerability that could lead to data breaches, financial losses, or damage to your reputation if not addressed quickly.</p>
                                                        </div>

                                                    </div>

                                                    <div className="card-body-wrap set-border">
                                                        <div className='reduce-your-risk-box'>
                                                            <div className="card-heading"><h5>What You Can Do to Reduce Your Risk </h5></div>

                                                            <div className='reduce-your-risk-list'>
                                                                <ListGroup>
                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Implement urgent training</p>
                                                                        <span>Launch an immediate and intensive awareness program to educate employees on phishing tactics and warning signs.</span>
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Reinforce technical safeguards</p>
                                                                        <span>Work with your IT team to review and strengthen email security measures, including advanced spam filters, multi-factor authentication,
                                                                            and threat detection.</span>
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Communicate regularly</p>
                                                                        <span>Keep employees updated on the latest phishing trends and how to recognize suspicious emails.</span>
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Establish rapid response protocols</p>
                                                                        <span>Make sure employees know how to report phishing attempts quickly, and have a dedicated team ready to investigate and act on those reports.</span>
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Audit your defenses</p>
                                                                        <span>Conduct a comprehensive review of security tools and policies to identify and fix any gaps</span>
                                                                    </ListGroup.Item>

                                                                    <ListGroup.Item>
                                                                        <p className="dot-text">Create a culture of accountability</p>
                                                                        <span>Foster an environment where every employee understands their role in protecting the organization from phishing threats.</span>
                                                                    </ListGroup.Item>

                                                                </ListGroup>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>) : (
                                                    (risk < mediumRiskThreshold && risk >= lowRiskThreshold) ? (
                                                        <div className="pdf-card-wrap mb-0">
                                                            <div className="heading">
                                                                <h5>Summary & Conclusion</h5>
                                                            </div>
                                                            <div className="card-body-wrap set-border mb-4">
                                                                <div className="summary-box">
                                                                    <p>A Medium {riskType} Rate indicates moderate exposure to phishing attacks, suggesting that some employees may be at risk of falling victim. This level of risk requires targeted improvements in training and defenses to prevent successful phishing attempts that could compromise sensitive data or disrupt operations.</p>
                                                                </div>

                                                            </div>

                                                            <div className="card-body-wrap set-border">
                                                                <div className='reduce-your-risk-box'>
                                                                    <div className="card-heading"><h5>What You Can Do to Reduce Your Risk </h5></div>

                                                                    <div className='reduce-your-risk-list'>
                                                                        <ListGroup>
                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Focus on at-risk groups:</p>
                                                                                <span>Identify departments or teams with higher risk scores and offer them targeted awareness programs.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Enhance training frequency</p>
                                                                                <span>Run phishing simulations and awareness training more frequently to build confidence and reduce risky behavior.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Strengthen your security posture</p>
                                                                                <span>Review email filtering tools and update them to block known phishing sources more effectively.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Promote security champions</p>
                                                                                <span>Encourage employees who demonstrate strong awareness to become advocates for security best practices across the organization.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Follow up consistently</p>
                                                                                <span>Track campaign results and adjust training strategies accordingly to close any gaps.</span>
                                                                            </ListGroup.Item>

                                                                        </ListGroup>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="pdf-card-wrap mb-0">
                                                            <div className="heading">
                                                                <h5>Summary & Conclusion</h5>
                                                            </div>
                                                            <div className="card-body-wrap set-border mb-4">
                                                                <div className="summary-box">
                                                                    <p>Your organization’s Low {riskType} Rate is a strong indicator of effective cybersecurity awareness and responsible behavior among your employees. It suggests that your team is well-equipped to identify and report phishing threats, reducing the likelihood of a successful phishing attack. However, staying ahead of evolving threats is essential to maintain this low risk.</p>
                                                                </div>

                                                            </div>

                                                            <div className="card-body-wrap set-border">
                                                                <div className='reduce-your-risk-box'>
                                                                    <div className="card-heading"><h5>What You Can Do to Reduce Your Risk </h5></div>

                                                                    <div className='reduce-your-risk-list'>
                                                                        <ListGroup>
                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Maintain training programs</p>
                                                                                <span>Continue phishing simulations and awareness to reinforce best practices and keep employees alert.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Encourage proactive reporting</p>
                                                                                <span>Remind employees to report any suspicious emails promptly, no matter how minor they seem.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Review security policies</p>
                                                                                <span> Periodically update your security guidelines to incorporate the latest threat intelligence.</span>
                                                                            </ListGroup.Item>

                                                                            <ListGroup.Item>
                                                                                <p className="dot-text">Leverage data</p>
                                                                                <span>Analyze past campaign results to identify any minor gaps and reinforce those areas.</span>
                                                                            </ListGroup.Item>

                                                                        </ListGroup>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                )

                                        )
                                    }


                                </div>

                            </div>

                            <div className="text-center mt-4">

                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                        this.state.disableDownloadReport ? (
                                            <Tooltip id="bottom"> <span>Please wait</span>
                                            </Tooltip>
                                        ) : (
                                            <Tooltip id="bottom" className="d-none" />
                                        )
                                    }
                                >
                                    <Dropdown>
                                        <Dropdown.Toggle variant="primary" disabled={this.state.isReportGenerating || this.state.disableDownloadReport}>
                                            {this.state.isReportGenerating ?
                                                <Spinner loading={this.state.isReportGenerating}></Spinner> : "Download"
                                            }
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu style={{fontSize: '12px'}}>
                                            <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "en"}) }}>English Report</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "ar"}) }}>Arabic Report</Dropdown.Item>
                                            <Dropdown.Item onClick={() => { if (!this.state.isReportGenerating && !this.state.disableDownloadReport) this.generatePdf({languageCode: "id"}) }}>Bahasa Report</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </OverlayTrigger>


                            </div>

                        </div>
                    </div>
                </div>


                <RightSideModalScheduler
                    show={this.state.showSchedulerModal}
                    handleModal={(status) => this.setState({ showSchedulerModal: status }, () => {
                        if (!status) {
                            this.setState({ selectedCampaignReportScheduler: {} });
                            this.fetchCampaignReportSchedulerByCampaignId();
                        }
                    })}
                    campaignReportScheduler={this.state.campaignReportScheduler}
                    simulationExpiresOn={this.state.latestSimulationExpiresOn}
                    campaignId={this.state.campaignId}
                />

                <RightSideModalSendReportToEmails
                    show={this.state.showSendReportToEmailsModal}
                    handleModal={(status) => this.setState({ showSendReportToEmailsModal: status })}
                    sendReportToEmails={async (emails) => {
                        await this.generatePdf({sendReportToEmails: emails});
                        this.setState({ showSendReportToEmailsModal: false });
                    }}
                    isReportGenerating={this.state.isReportGenerating}
                />


                <DebouncedLoader loading={this.state.loading}/>
                {this.state.isReportDownloaded && <span id='report-downloaded-successfully'>&nbsp;</span>}
            </div>
        );
    }
}
